import PropTypes from 'prop-types'
import React from 'react'

/**
 * To use this component, just pass anything you want to apply the scroll loading effect as children.
 *
 * eg. `<ScrollLoader><el1 /><el2 /></ScrollLoader>`
 *
 * Props
 * @param activeClassName classname when the scroll is loaded. default `active`
 * @param className classname which you can use to styling from the parent component. default `scroll-loader`
 * @param id same as normal html behavior
 * @param threshold percentage divide by 100 of the threshold to toggle active. default 0.1
 */
class ScrollLoader extends React.PureComponent {
  state = { isActive: false }

  wrapperEl = React.createRef()

  componentDidMount() {
    if ('IntersectionObserver' in window) {
      this.startListener()
    } else {
      this.showContent()
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect()
  }

  startListener() {
    const { deferOut, threshold } = this.props
    const options = { threshold }

    this.observer = new IntersectionObserver((entries) => {
      entries.some((entry) => {
        if (entry.isIntersecting) {
          this.showContent()

          if (!deferOut) {
            this.observer.disconnect()
            return true
          }
        } else if (deferOut) {
          this.setState({ isActive: false })
        }
        return undefined
      })
    }, options)

    this.observer.observe(this.wrapperEl.current)
  }

  showContent() {
    this.setState({ isActive: true })
  }

  render() {
    const {
      activeClassName,
      children,
      className: inputClassName,
      id,
    } = this.props
    const { isActive } = this.state
    let className = inputClassName

    if (isActive) {
      className += ` ${activeClassName}`
    }

    return (
      <div className={className} id={id} ref={this.wrapperEl}>
        {children}
      </div>
    )
  }
}

ScrollLoader.defaultProps = {
  activeClassName: 'active',
  className: 'scroll-loader',
  deferOut: false,
  id: '',
  threshold: 0.1,
}

ScrollLoader.propTypes = {
  activeClassName: PropTypes.string,
  children: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  deferOut: PropTypes.bool,
  id: PropTypes.string,
  threshold: PropTypes.number,
}

export default ScrollLoader
